import type { JSX } from 'react'
import type { IBannerProps } from '../../Banner'

import { Link } from 'atoms/Link'
import { BANNER_ASPECT_RATIO, BANNER_PADDINGS, BANNER_WIDTH } from 'vars/index'
import { BannerTemplate } from '../Templates.styled'

export interface IBannerEmptyLargeProps extends IBannerProps {
  link?: string
}

export const BannerEmptyLarge = ({
  posterUrl = '',
  width = BANNER_WIDTH.SIZE_100,
  aspectRatio = BANNER_ASPECT_RATIO.SIZE_10,
  paddings = BANNER_PADDINGS.SIZE_10,
  link,
  ...rest
}: IBannerEmptyLargeProps): JSX.Element => (
  <Link href={link}>
    <BannerTemplate
      posterUrl={posterUrl}
      width={width}
      aspectRatio={aspectRatio}
      paddings={paddings}
      isPartialPoster={false}
      noContentInside
      {...rest}
    />
  </Link>
)
